import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle<{
  $bgVariant?: 'base' | 'primary'
}>`
  :root {
      *,
      *::before,
      *::after {
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
      }

      img {
        pointer-events: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;
      }

      button {
        -webkit-user-select: none;
        user-select: none;
      }

      input[type='number'] {
        -moz-appearance: textfield;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      body {
        position: relative;
        padding: 0;
        margin: 0;
        background: ${({ $bgVariant, theme }) =>
          $bgVariant === 'primary'
            ? theme.colors['N Surface/Primary']
            : theme.colors['N Surface/Base']};
        color: ${({ theme }) => theme.colors['N Content/Secondary']};
        font-family: ${({ theme }) => theme.fonts.text};
      }
  }
`
